import { TRPCClientError } from '@trpc/client';

export const isTrpcForbidden = (error: unknown): boolean =>
  error instanceof TRPCClientError && error.data?.code === 'FORBIDDEN';

export const isNoAccountLinked = (error: unknown): boolean =>
  error instanceof TRPCClientError &&
  (error.data as { noAccountLinked?: boolean } | null | undefined)?.noAccountLinked === true;
